import { ActionTree } from "vuex";
import { WhiteboardState } from "./state";

const actions: ActionTree<WhiteboardState, any> = {
  //
};

export default actions;
